import { Button, Grid } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React from 'react';
import FormikInput from '../../../../components/atom/FormikInput';

const ReaderCreateOrEditForm = ({ initialValues, onSubmit, isCreate, onBack }) => {
    const defaultValues = {
        label: initialValues?.label ?? '',
        registration_code: initialValues?.registration_code ?? ''
    };

    return (
        <Formik initialValues={defaultValues} enableReinitialize onSubmit={onSubmit}>
            {({ isSubmitting }) => (
                <>
                    <Form>
                        <Grid container item xs={12} spacing={2}>
                            <Grid item container xs={12} spacing={2} className="mb-2">
                                <Grid item xs={12}>
                                    <h5>Data</h5>
                                </Grid>
                                <FormikInput
                                    name="label"
                                    label="Custom label for easier identification"
                                    xs={6}
                                />
                                {isCreate && (
                                    <FormikInput
                                        name="registration_code"
                                        label="Registration code (generated by the reader)"
                                        xs={6}
                                    />
                                )}
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                spacing={2}
                                justifyContent="flex-end"
                                className="mb-2"
                            >
                                <Button
                                    variant="contained"
                                    onClick={onBack}
                                    style={{ marginRight: '5px' }}
                                >
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </>
            )}
        </Formik>
    );
};

export default ReaderCreateOrEditForm;
